import React, { useEffect, useState, useCallback } from "react";
import { Card, CardContent, Typography, List, ListItem, Avatar, Button, Box, Skeleton } from "@mui/material";
import { baseUrl, get } from "../../services/api-services";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { useCommon } from "../../context/CommonContext";
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../modules/ConvertDate";
const supportCache = { data: null };

const SupportDashboard = ({ parentLoading }) => {
    const [supportTopics, setSupportTopics] = useState(supportCache.data || []);
    const [loading, setLoading] = useState(!supportCache.data);
    const navigate = useNavigate();
    const onGetSupport = useCallback(async () => {
        if (!supportCache.data) setLoading(true);
        let url = `/SupportTopics?filter={"include" : [{"relation" : "chats", "scope" : {"order": "createdAt DESC"}}, {"relation" : "customer"}], "order": "lastCustomerMsgOn DESC", "limit" : "5"}`;
        const res = await get(url);
        if (res?.statusCode === 200) {
            setSupportTopics(res?.data);
            supportCache.data = res?.data;
        }
        setLoading(false);
    }, [])
    useEffect(() => {
        onGetSupport();
    }, [onGetSupport])
    return (
        <Card className="flex flex-col flex-1 mt-[20px]">
            <CardContent className="flex flex-col flex-1 relative">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h" className="font-bold">
                        Support
                    </Typography>
                </Box>
                {loading || parentLoading ? (
                    <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                        {Array.from({ length: 4 }).map((_, i) => (
                            <ListItem key={i} disablePadding>
                                <ListItemButton>
                                    <Box alignItems="flex-start">
                                        <ListItemAvatar>
                                            <Skeleton variant="circular" width={40} height={40} animation="wave" />
                                        </ListItemAvatar>
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Skeleton variant="text" width="50%" animation="wave" />
                                        <Skeleton variant="text" width="70%" animation="wave" />
                                        <Skeleton variant="text" width="40%" animation="wave" />
                                    </Box>
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                ) : supportTopics?.length > 0 ? <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                    {supportTopics?.map((topic, index) => {
                        return (
                            <ListItem
                                key={topic?.id || `${topic?.customer?.id || "topic"}-${index}`}
                                secondaryAction={
                                    <Typography
                                        variant="body2"
                                        sx={{ color: '#bdbdbd' }}
                                    >
                                        {formatDate(topic.lastCustomerMsgOn)}
                                    </Typography>
                                }
                                disablePadding
                                onClick={() => navigate('/admin/support', { state: { id: topic?.id } })}
                            >
                                <ListItemButton>
                                    <Box alignItems="flex-start">
                                        <ListItemAvatar>
                                            <Avatar
                                                src={topic.customer?.image ? `${baseUrl}/Uploads/profile-pic/download/${topic.customer?.image}` : "/assets/userProfile.png"}
                                                alt={topic?.customer?.name}
                                            />
                                        </ListItemAvatar>
                                    </Box>
                                    <Box>
                                        <Typography variant="body1">{topic.customer?.name}</Typography>
                                        <Typography variant="body2" color="textSecondary">{topic.topic}</Typography>
                                        <Typography variant="body2" color="textSecondary" style={{ marginTop: "5px" }}>
                                            {topic.chats[0]?.message?.split(" ").slice(0, 5).join(" ") + (topic.chats[0]?.message?.split(" ").length > 5 ? "..." : "")}
                                        </Typography>

                                    </Box>
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>
                    : <div className="flex flex-col flex-1 justify-center items-center">
                        <p>No Support Message yet</p>
                    </div>}
                <Button color="primary" sx={{ textTransform: 'none' }} className="absolute left-0 bottom-0 max-w-[120px]" onClick={() => navigate('/admin/support')} endIcon={<ChevronRightOutlinedIcon />}>View All</Button>
            </CardContent>
        </Card>
    );
};

export default SupportDashboard;
